import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { HealthPlanResponse } from '@/modules/HealthPlan/HealthPlan.types';

interface Data {
  dto: Partial<HealthPlanResponse>;
  successCallback?: () => void;
}

export const useUpdateHealthPlanByIdQuery = (id: string, errorCallback?: (error: unknown) => void) => {
  const mutation = useMutation(
    ({ dto, successCallback }: Data) =>
      api.put<HealthPlanResponse>(API_URL.HEALTH_PLANS_BY_HEALTH_PLAN_ID(id), dto).then((data) => {
        if (successCallback) {
          successCallback();
        }
        return data;
      }),
    {
      onError: (error) => {
        if (errorCallback) {
          errorCallback(error);
        }
      },
    }
  );
  return mutation;
};
export default useUpdateHealthPlanByIdQuery;
